import { fromJS } from 'immutable';
import * as R from 'ramda';
import * as webpageActions from '../actions/webpage';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  fields: {},
  searchOptions: {},
  webpageList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
    loadingAction: '',
    deletionError: null,
  },
  tagList: {},
  webpage: {},
  notes: {},
};

export default (state = fromJS(initialStats), action) => {
  let newState;
  let newWebpages;
  switch (action.type) {
    case webpageActions.WEBPAGE_SEARCH_OPTIONS_FETCH_START:
      return state.setIn(['searchOptions', 'state'], fetchingState.FETCHING);
    case webpageActions.WEBPAGE_SEARCH_OPTIONS_FETCH_SUCCESS:
      newState = state.setIn(['searchOptions', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['searchOptions', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case webpageActions.WEBPAGE_SEARCH_OPTIONS_FETCH_ERROR:
      return state.setIn(['searchOptions', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_FIELDS_FETCH_START:
      return state.setIn(['fields', 'state'], fetchingState.FETCHING);
    case webpageActions.WEBPAGE_FIELDS_FETCH_SUCCESS:
      newState = state.setIn(['fields', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['fields', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case webpageActions.WEBPAGE_FIELDS_FETCH_ERROR:
      return state.setIn(['fields', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_TAGS_FETCH_START:
      return state.setIn(['tagList', 'state'], fetchingState.FETCHING);
    case webpageActions.WEBPAGE_TAGS_FETCH_SUCCESS:
      newState = state.setIn(['tagList', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['tagList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case webpageActions.WEBPAGE_TAGS_FETCH_ERROR:
      return state.setIn(['tagList', 'state'], fetchingState.ERROR);

    // case webpageActions.WEBPAGE_SEARCH_START:
    //   return state.setIn([ 'webpageList', 'state' ], fetchingState.FETCHING);
    // case webpageActions.WEBPAGE_SEARCH_SUCCESS:
    //   newState = state.setIn([ 'webpageList', 'state' ], fetchingState.LOADED);
    //   newState = newState.setIn([ 'webpageList', 'totalCount' ], (action.data && action.data.totalWebpage) ? action.data.totalWebpage.webpageCount : 0);
    //   return newState.setIn([ 'webpageList', 'data' ], fromJS(action.data ? action.data.results : []));
    // case webpageActions.WEBPAGE_SEARCH_ERROR:
    //   return state.setIn([ 'webpageList', 'state' ], fetchingState.ERROR);
    case webpageActions.WEBPAGE_LIST_FETCH[START]:
      return state.setIn(['webpageList', 'state'], fetchingState.FETCHING);
    case webpageActions.WEBPAGE_LIST_FETCH[SUCCESS]:
      newState = state.setIn(['webpageList', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['webpageList', 'totalCount'],
        action.data && action.data.results ? action.data.results.length : 0,
      );
      return newState.setIn(
        ['webpageList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case webpageActions.WEBPAGE_LIST_FETCH[ERROR]:
      return state.setIn(['webpageList', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_CHANGE_CURRENT_PAGE:
      return state.setIn(['webpageList', 'currentPage'], action.data);
    case webpageActions.WEBPAGE_CHANGE_PAGE_SIZE:
      return state.setIn(['webpageList', 'pageSize'], action.data);
    case webpageActions.WEBPAGE_CHANGE_SORT_MODEL:
      return state.setIn(['webpageList', 'sortModel'], fromJS(action.data));

    case webpageActions.WEBPAGE_FETCH_START:
      return state.setIn(['webpage', 'state'], fetchingState.FETCHING);
    case webpageActions.WEBPAGE_FETCH_SUCCESS:
      newState = state.setIn(['webpage', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['webpage', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case webpageActions.WEBPAGE_FETCH_ERROR:
      return state.setIn(['webpage', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_NOTES_FETCH_START:
      return state.setIn(['notes', 'state'], fetchingState.FETCHING);
    case webpageActions.WEBPAGE_NOTES_FETCH_SUCCESS:
      newState = state.setIn(['notes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['notes', 'data'],
        fromJS(action.data ? action.data.results : null),
      );
    case webpageActions.WEBPAGE_NOTES_FETCH_ERROR:
      return state.setIn(['notes', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_UPDATE_START:
      return state.setIn(['webpage', 'state'], fetchingState.SAVING);
    case webpageActions.WEBPAGE_UPDATE_SUCCESS:
      newState = state.setIn(['webpage', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['webpage', 'data'],
        fromJS(action.data.results[0]),
      );
    case webpageActions.WEBPAGE_UPDATE_ERROR:
      return state.setIn(['webpage', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_RESET_DATA:
      return state.setIn(['webpage'], fromJS({}));

    case webpageActions.WEBPAGE_CREATE[START]:
      return state.setIn(['webpage', 'state'], fetchingState.SAVING);
    case webpageActions.WEBPAGE_CREATE[SUCCESS]:
      newState = state.setIn(['webpage', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['webpage', 'data'],
        fromJS(action.data.results[0]),
      );
    case webpageActions.WEBPAGE_CREATE[ERROR]:
      return state.setIn(['webpage', 'state'], fetchingState.ERROR);

    case webpageActions.WEBPAGE_DUPLICATE[START]:
      return state.setIn(['webpageList', 'loadingAction'], 'duplicate');
    case webpageActions.WEBPAGE_DUPLICATE[ERROR]:
      return state.setIn(['webpageList', 'loadingAction'], '');
    case webpageActions.WEBPAGE_DUPLICATE[SUCCESS]:
      newWebpages = state.getIn(['webpageList', 'data']).toJS();
      newWebpages = [action.data.results[0], ...newWebpages];
      newState = state.setIn(['webpageList', 'loadingAction'], '');
      return newState.setIn(['webpageList', 'data'], fromJS(newWebpages));

    case webpageActions.WEBPAGE_DELETE[SUCCESS]:
      newWebpages = state.getIn(['webpageList', 'data']).toJS();
      newWebpages = newWebpages.filter(n => n.pageID !== action.webpageId);
      return state.setIn(['webpageList', 'data'], fromJS(newWebpages));
    case webpageActions.WEBPAGE_DELETE[ERROR]:
      return state.setIn(
        ['webpageList', 'deletionError'],
        fromJS(R.path(['error', 'body', 'error', 'error'])(action)),
      );

    case webpageActions.WEBPAGE_VALIDATE_SUCCESS:
      return state.setIn(['webpage', 'data'], fromJS(action.data.results[0]));

    case webpageActions.WEBPAGE_NOTE_ADD_SUCCESS:
      let newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.concat(action.data.results);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case webpageActions.WEBPAGE_NOTE_DELETE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      newNotes = newNotes.filter(n => n.noteID !== action.noteId);
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    case webpageActions.WEBPAGE_NOTE_UPDATE_SUCCESS:
      newNotes = state.getIn(['notes', 'data']).toJS();
      return state.setIn(['notes', 'data'], fromJS(newNotes));

    default:
      return state;
  }
};
